export default __webpack_public_path__ + "static/media/IMG-20241005-WA0049.ce238c6f.jpg";